import { useCallback } from 'react';
import { useApolloClient } from '@apollo/client';
import { Mutations } from 'apollo';

const useVerifyEmployee = () => {
  const client = useApolloClient();
  return useCallback(
    submissionData =>
      client
        .mutate({
          fetchPolicy: 'no-cache',
          mutation: Mutations.VerifyEmployee,
          variables: submissionData,
        })
        .then(response => (response.data || {}).verifyEmployee || []),
    [client],
  );
};

export default useVerifyEmployee;
